export const breakpoint = {
  xs: 350,
  s: 420,
  m: 745,
  l: 1200,
  xl: 1800
}